import { render, staticRenderFns } from "./DashboardsLayout.vue?vue&type=template&id=8870af98"
import script from "./DashboardsLayout.vue?vue&type=script&lang=js"
export * from "./DashboardsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports